import { render, staticRenderFns } from "./releases_sort.vue.js?vue&type=template&id=69875812&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./releases_sort.vue?vue&type=template&id=69875812&vue3"
import script from "./releases_sort.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./releases_sort.vue?vue&type=script&lang=js&vue3"
export * from "./releases_sort.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./releases_sort.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports